import React, { useState, useEffect } from 'react';
import axios from '../api/api';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

const TwoFaLogin = ({ setAccessToken }) => {

  const [code, setCode] = useState('');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem('token')
  const tokenData = JSON.parse(token)?.data.access_token;
  const bearer = tokenData

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true)
    try {
      const token = await axios.post('/auth/2fa-login',
        { code },
        {
          headers: { 
            'Content-type': 'application/json',
            'Authorization': `Bearer ${bearer}`
          },
        }
      );
      toast.success('Login Successful');
      navigate('/app/dashboard');
      setAccessToken(token);
    } catch (error) {
      if (!error?.response) {
        toast.error('Network error! Check your connection.');
      } else if (error.response?.status) {
      toast.error(error.response.data.detail);
      } else {
      toast.error('User Verification Failed');
      }
      console.log(error.response);
    } finally {
      setLoading(false)
    }
  };

  const resendCode = async () => {
    setLoading(true);
    try {
      await axios.post('/auth/resend-otp-code');
      toast.success("New Two Step Verification code sent to phone.");
    } catch (error) {
      console.log(error);
      if (!error?.response) {
        toast.error('Network error! Check your connection.');
      } else if (error.response.status) {
        toast.error(error.response.data.detail)
      } else {
        toast.error('Oops! Something went wrong. Could not resend code.')
      }
    } finally {
      setLoading(false);
    }
  }

  const twofatoken = window.localStorage.getItem('token');
  const auth_token = JSON.parse(twofatoken)?.data.token_use;

  useEffect(() => {
    if (auth_token !== '2fa_login') {
      navigate('/login')
    }
  
  },[auth_token, navigate])

  return (
    <div className='flex items-center justify-center h-screen'>
      <div className='mx-auto p-4 bg-white rounded-lg'>
        <h4 className='font-bold text-center text-[#134463]'>Enter Two Step Verification Code</h4>
        <form onSubmit={handleSubmit}>
          <div className='mt-2'>
            <label htmlFor='code'>Verification Code
              <input
                type='number'
                required
                placeholder='Code'
                className='px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                value={code}
                onChange={(e) => setCode(e.target.value)}
              />
            </label>
          </div>
          <div className='mt-2'>
            <button disabled={loading} className='px-3 py-1 w-full bg-[#134463] text-white hover:bg-[#134463]'>{loading ? 'Verifying...' : 'Verify'}</button>
          </div>
        </form>
        <div className="mt-4 text-center text-sm text-gray-600">
              <p>Need a new code? <button onClick={resendCode} className="font-bold text-[#134463] hover:text-[#4c6e83]">Resend Code</button></p>
            </div>
      </div>
    </div>
  );
};

export default TwoFaLogin;
